import {
  Card,
  CardContent,
  CardHeader,
  Link,
  List,
  ListItem,
  Stack,
  Typography,
  Box,
} from "@mui/material";

type MenuItem = {
  label: string;
  href?: string;
  newTab?: boolean;
  onClick?: () => void;
};

const MenuCard: React.FC<{
  title: string;
  icon: React.ReactNode;
  items: MenuItem[];
}> = ({ title, icon, items }) => {
  const logoutItem = items.find((i) => i.label.toLowerCase() === "log out");
  const otherItems = items.filter((i) => i.label.toLowerCase() !== "log out");

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "10px",
        border: "2px solid #e6ecf0",
      }}
    >
      <CardHeader
        title={
          <Stack direction="row" alignItems="center" spacing={1}>
            {icon}
            <Typography
              sx={{ fontSize: "14px", color: "#494440", fontWeight: "bold" }}
            >
              {title}
            </Typography>
          </Stack>
        }
      />
      <CardContent
        sx={{ flex: 1, display: "flex", flexDirection: "column", p: 0 }}
      >
        <List dense sx={{ flex: 1, p: 0 }}>
          {otherItems.map((it) => (
            <ListItem key={`${it.href}-${it.label}`} sx={{ px: 2 }}>
              <Link
                href={it.href}
                onClick={it.onClick}
                underline="none"
                sx={{ color: "#54AFE2", fontSize: "14px", cursor: "pointer" }}
                target={it.newTab ? "_blank" : undefined}
                rel={it.newTab ? "noopener noreferrer" : undefined}
              >
                {it.label}
              </Link>
            </ListItem>
          ))}
        </List>

        {logoutItem && (
          <Box
            sx={{
              p: 2,
              mt: "auto",
            }}
          >
            <Link
              href={logoutItem.href}
              underline="none"
              sx={{ color: "#54AFE2", fontSize: "14px" }}
              target={logoutItem.newTab ? "_blank" : undefined}
              rel={logoutItem.newTab ? "noopener noreferrer" : undefined}
            >
              {logoutItem.label}
            </Link>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MenuCard;
